import { restApiActions } from 'redux/redux-actions';

export const contactsReinviteActions = restApiActions('contacts', 're-invite');
export default restApiActions('contacts');
